import { FC } from "react";

import { List } from "antd";

import { IUser } from "@/models/User";
import UserItem from "../UserItem";

interface UserListProps {
  users: IUser[];
  editUser: (user: IUser) => void;
  deleteUser: (id: number) => void;
}

const UserList: FC<UserListProps> = ({ users, editUser, deleteUser }) => {
  return (
    <List
      size="small"
      bordered
      dataSource={users}
      renderItem={(user) => (
        <List.Item>
          <UserItem user={user} deleteUser={deleteUser} editUser={editUser} />
        </List.Item>
      )}
    />
  );
};

export default UserList;
